import defaultTranslations from './en';

export default {
  // Common
  "appName": "Qonso",
  "loading": "Loading...",
  "error": "An error occurred",
  "success": "Success",
  "save": "Save",
  "cancel": "Cancel",
  "confirm": "Confirm",
  "back": "Back",
  "backToHome": "Back to Home",
  "backToLogin": "Back to Login",
  "backToForgotPassword": "Back to Forgot Password",
  "next": "Next",
  "submit": "Submit",
  "delete": "Delete",
  "edit": "Edit",
  "view": "View",
  "close": "Close",
  "and": "and",
  "pleaseWait": "Please wait...",
  "verifyingLink": "Verifying your link",
  
  // Auth
  "login": "Login",
  "register": "Register",
  "forgotPassword": "Forgot Password",
  "resetPassword": "Reset Password",
  "email": "Email",
  "password": "Password",
  "confirmPassword": "Confirm Password",
  "fullName": "Full Name",
  "age": "Age",
  "country": "Country",
  "signIn": "Sign In",
  "signUp": "Sign Up",
  "signOut": "Sign Out",
  "createAccount": "Create Account",
  "creatingAccount": "Creating Account...",
  "signingIn": "Signing In...",
  "signInToTrack": "Sign in to track your hydration journey",
  "joinQonsoToday": "Join Qonso today and start your hydration journey!",
  "alreadyHaveAccount": "Already have an account?",
  "dontHaveAccount": "Don't have an account?",
  "rememberPassword": "Remember your password?",
  "forgotPasswordQuestion": "Forgot your password?",
  "resetPasswordInstructions": "Enter your email and we'll send you a link to reset your password",
  "sendResetLink": "Send Reset Link",
  "sending": "Sending...",
  "passwordResetSent": "Password reset link sent to your email. Please check your inbox and follow the instructions.",
  "passwordUpdated": "Password updated successfully",
  "passwordsDoNotMatch": "Passwords do not match",
  "passwordMinLength": "Password must be at least 6 characters",
  "emailRequired": "Email is required",
  "passwordRequired": "Password is required",
  "fullNameRequired": "Full name is required",
  "ageRequired": "Age is required",
  "countryRequired": "Country is required",
  "acceptTerms": "I accept the",
  "termsRequired": "You must accept the terms to continue",
  "emailConfirmationRequired": "Please check your email to confirm your account",
  "emailConfirmationSent": "A confirmation email has been sent to your address. Please check your inbox and follow the instructions to complete your registration.",
  "emailConfirmationSuccess": "Your email has been confirmed successfully!",
  "emailConfirmationFailed": "Email confirmation failed",
  "emailConfirmed": "Email Confirmed",
  "emailVerifiedRedirect": "Your email has been verified. You will be redirected to the dashboard.",
  "confirmingEmail": "Confirming your email",
  "pleaseWaitVerifying": "Please wait while we verify your email...",
  "invalidConfirmationLink": "Invalid confirmation link",
  "failedToConfirmEmail": "Failed to confirm email",
  "goToDashboard": "Go to Dashboard",
  "selectCountry": "Select a country",
  "selectCountries": "Select countries",
  "leaveEmptyForAllCountries": "Leave empty to make available in all countries",
  "targetCountries": "Target Countries",
  "allCountries": "All Countries",
  "pleaseAllFields": "Please fill all required fields",
  "loginFailed": "Incorrect email or password. Please try again.",
  "registrationFailed": "Registration failed. Please try again.",
  "emailAlreadyRegistered": "This email is already registered",
  "invalidEmail": "Please enter a valid email address",
  "invalidAge": "Please enter a valid age",
  "invalidPassword": "Invalid password format",
  "currentPassword": "Current Password",
  "newPassword": "New Password",
  "confirmNewPassword": "Confirm New Password",
  "updating": "Updating...",
  "emailCannotBeChanged": "Email cannot be changed",
  "tooManyAttempts": "Too many attempts. Please try again in a few minutes.",
  "sessionExpired": "Your session has expired. Please sign in again.",
  "networkError": "Network error. Please check your connection and try again.",
  "unknownError": "An unexpected error occurred. Please try again.",
  "checkYourEmail": "Check your email",
  "didntReceiveEmail": "Didn't receive the email?",
  "resendEmail": "Resend email",
  "emailConfirmedInstructions": "Your email has been confirmed successfully. You can now sign in to your account.",
  "proceedToLogin": "Proceed to Login",
  "passwordResetInstructions": "We will send you a link by email to reset your password.",
  "resetLinkSent": "A new reset link has been sent",
  "resetLinkFailed": "Failed to send reset link",
  "emailVerificationInstructions": "You will receive a link by email to confirm your registration.",
  "setNewPassword": "Set New Password",
  "createNewPassword": "Create a new password for your account",
  "passwordResetComplete": "Your password has been reset. You can now use your new password to access your account.",
  "passwordUpdateFailed": "Failed to update password. Please try again.",
  "invalidResetLink": "Invalid or expired password reset link",
  "errorResendingEmail": "Error resending verification email. Please try again later.",
  
  // Admin
  "adminLogin": "Administrator Login",
  "adminLoginDescription": "Sign in to access the administrator dashboard",
  
  // Home
  "mainTitle": "Hydrate, Collect, Win! 💧",
  "mainTitleHighlight": "With Qonso, earn rewards by drinking water",
  "homeDescription": "Qonso helps you stay hydrated while rewarding you for your good habits. Drink water, earn points, and redeem them for exciting gifts.",
  "getStarted": "Get Started",
  "features": "Features",
  "whyUseQonso": "Why Use Qonso?",
  "featuresDescription": "Discover how Qonso helps you maintain healthy hydration habits while making it fun and rewarding.",
  "trackHydration": "Track Hydration",
  "trackHydrationDescription": "Log your daily water intake and monitor your progress with our easy-to-use tracking system.",
  "dailyGoals": "Daily Goals",
  "dailyGoalsDescription": "Qonso encourages you to reach a daily goal of 2.5 L of water.",
  "participateSurveys": "Participate in Surveys",
  "participateSurveysDescription": "Earn more points by participating in our different surveys.",
  "redeemRewards": "Redeem Rewards",
  "redeemRewardsDescription": "Convert your earned points into exciting rewards and special offers.",
  
  // Benefits section
  "benefitsOfHydration": "Benefits of Staying Hydrated",
  "benefitsDescription": "Proper hydration is essential for your health and wellbeing. Here's why you should track your water intake with Qonso.",
  "improvedEnergyLevels": "Improved Energy Levels",
  "improvedEnergyDescription": "Staying hydrated helps maintain your energy levels throughout the day, reducing fatigue and improving focus.",
  "betterPhysicalPerformance": "Better Physical Performance",
  "betterPhysicalDescription": "Proper hydration enhances physical performance during exercise and daily activities.",
  "enhancedCognition": "Enhanced Cognitive Function",
  "enhancedCognitionDescription": "Water helps your brain function optimally, improving concentration and memory.",
  "healthierSkin": "Healthier Skin",
  "healthierSkinDescription": "Staying hydrated helps maintain skin elasticity and promotes a healthier, more radiant complexion.",
  "improvedDigestion": "Improved Digestion",
  "improvedDigestionDescription": "Water is essential for proper digestion and helps prevent constipation.",
  "joinCommunity": "Join Our Community",
  "joinCommunityDescription": "Connect with thousands of users who are improving their hydration habits with Qonso.",
  
  // Testimonials
  "userTestimonials": "What Our Users Say",
  "testimonialsDescription": "Join thousands of satisfied users who have improved their hydration habits with Qonso.",
  "testimonial1": "Qonso has completely changed how I track my water intake. The rewards system keeps me motivated!",
  "testimonialRole1": "Fitness Enthusiast",
  "testimonial2": "I never realized how little water I was drinking until I started using Qonso. Now I'm properly hydrated every day.",
  "testimonialRole2": "Office Worker",
  "testimonial3": "The surveys and rewards make staying hydrated fun. I've redeemed several rewards already!",
  "testimonialRole3": "Student",
  
  // CTA
  "ctaHeading": "Ready to Start Your Hydration Journey?",
  "ctaDescription": "Join Qonso today and transform your hydration habits while earning exciting rewards.",
  
  // Dashboard
  "welcomeBack": "Hello",
  "hydrationTracking": "Validate your water consumption to earn points",
  "dailyGoal": "Daily Goal",
  "streak": "Streak",
  "points": "Points",
  "daysInARow": "Days in a row",
  "totalEarned": "Total points earned",
  "validateConsumption": "💧Log Your Water Intake",
  "dailyLimitReached": "Daily Limit Reached",
  "limitReached": "Daily limit reached!",
  "comeBackTomorrow": "Well Done! You've Logged Today's Consumption. See You Tomorrow? 😉",
  "waterType": "Water Type",
  "plainWater": "Plain Water",
  "plainWaterDesc": "Regular water",
  "mineralWater": "Mineral Water",
  "mineralWaterDesc": "Natural mineral water",
  "sparklingWater": "Sparkling Water",
  "sparklingWaterDesc": "Carbonated water",
  "flavoredWater": "Flavored Water",
  "sunday": "Sun",
  "monday": "Mon",
  "tuesday": "Tue",
  "wednesday": "Wed",
  "thursday": "Thu",
  "friday": "Fri",
  "saturday": "Sat",
  "flavoredWaterDesc": "Water with natural flavors",
  "uploadPhoto": "Please take a photo of your glass or bottle of water",
  "photoSelected": "Photo Selected",
  "photoRequired": "Please take a photo of your water",
  "fixedAmount": "Water volume", 
  "dailyProgress": "Progress",
  "consumptionValidated": "Water consumption validated",
  "validate": "Validate",
  "validating": "Validating",
  "totalWaterConsumed": "Total Water Consumed",
  "lifetimeConsumption": "Lifetime consumption",
  "ofDailyGoals": "of daily goals",
  "showWeeklyStats": "Show Weekly Stats",
  "hideWeeklyStats": "Hide Weekly Stats",
  "weeklyProgress": "Weekly Progress",
  "lastWeek": "Last Week",
  "today": "Today",
  "insights": "Insights",
  "streak": "Streak",
  "days": "d",
  "points": "Points",
  "time": "Time",
  "weeklyProgress": "7 Days",
  "total": "Total",
  "goals": "Goals",
  "lifetimeAchievement": "You've consumed a total of",
  "ofWater": "of water since you started",
  "startTrackingToday": "Start tracking your water consumption today!",
  "keepUpStreak": "Keep up your {{streak}}-day streak!",
  "startStreak": "Start your streak today!",
  
  // Rewards
  "rewards": "Rewards",
  "rewardsCatalog": "Rewards Catalog",
  "rewardHistory": "Reward History",
  "rechargeCard": "Recharge Card",
  "giftCard": "Gift Card",
  "request": "Request",
  "requestReward": "Request Reward",
  "notEnoughPoints": "Not enough points",
  "rewardRequested": "Reward requested successfully",
  "errorRequestingReward": "Error requesting reward",
  "reward": "Reward",
  "status": "Status",
  "pending": "Pending",
  "approved": "Approved",
  "rejected": "Rejected",
  "requestDate": "Request Date",
  "noRewardRequests": "No reward requests",
  "yourPoints": "Your points",
  "noRewards": "No reward available at the moment",
  "pendingRequest": "Request in progress",
  "alreadyRequestedReward": "You already have a pending request for this reward",
  "pleaseLogin": "Please login to request rewards",
  
  // Partner Offers
  "partnerOffers": "Partner Offers",
  "noPartnerOffers": "No partner offer available",
  "claimOffer": "View",
  "requesting": "Request in progress...",
  "errorFetchingPartnerOffers": "Error when retrieving partner offers",
  "currentImage": "Current image",
  
  // Surveys
  "surveys": "Surveys",
  "availableSurveys": "Available Surveys",
  "startSurvey": "Start Survey",
  "noSurveysAvailable": "No surveys available",
  "surveyCompleted": "Survey completed! You earned {{points}} points",
  "completeSurvey": "Complete Survey",
  "nextQuestion": "Next Question",
  "question": "Question",
  "pointsWorth": "Worth",
  "completedSurveys": "Completed Surveys",
  "noCompletedSurveys": "No completed surveys",
  "completedDate": "Completion Date",
  "yes": "Yes",
  "no": "No",
  
  // Settings
  "settings": "Settings",
  "profileSettings": "Profile Settings",
  "changePassword": "Change Password",
  "updateProfile": "Update Profile",
  "updatePassword": "Update Password",
  "profileUpdated": "Profile updated successfully",
  "passwordUpdated": "Password updated successfully",
  "deleteAccount": "Delete Account",
  "deleteMyAccount": "Delete My Account",
  "deleteAccountDescription": "If you wish to delete your account and all associated data, please click the button below. This action will redirect you to a form where you can submit your deletion request.",
  
  // Navigation
  "dashboard": "Dashboard",
  "notifications": "Notifications",
  "noNotifications": "No notifications",
  "markAllAsRead": "Mark all as read",
  "markAsRead": "Mark as read",
  
  // Footer
  "privacyPolicy": "Privacy Policy",
  "termsOfService": "Terms of Service",
  "legalNotice": "Legal Notice",
  "contact": "Contact",
  "contactEmail": "contact@qonso.app",
  "allRightsReserved": "© 2025 Qonso. All rights reserved."
};